/**
 * Wings and look weapons sold one by one on the shop's home (ADR 0031, 0053):
 * no pack, no stats, never found in the world. The wings are drawn on the
 * bare body and beat in four frames like the founder's; each weapon is one
 * upright drawing at 64 px, reduced to its icon and to the held piece
 * (ADR 0005), worn over the real weapon.
 */
const wing = (id, name, rarity) => ({
    id,
    lootable: false,
    cosmetic: true,
    name,
    kind: 'equipment',
    slot: 'wings',
    rarity,
    sprite: `overlay.${id}`,
    icon: `icon.${id}`,
});
const weapon = (id, name, rarity) => ({
    id,
    lootable: false,
    cosmetic: true,
    name,
    kind: 'equipment',
    slot: 'weapon',
    rarity,
    sprite: `overlay.${id}`,
    icon: `icon.${id}`,
});
const templates = [
    wing('butterfly-wings', 'Ailes de papillon', 'epic'),
    wing('angel-wings', 'Ailes d’ange', 'legendary'),
    wing('bat-wings', 'Ailes de chauve-souris', 'epic'),
    weapon('crystal-sword', 'Épée de cristal', 'epic'),
    weapon('banner-spear', 'Lance-étendard', 'rare'),
    // The joke of the shop: green and white, never mistaken for the tutorial's wooden sword.
    weapon('battle-leek', 'Poireau de combat', 'rare'),
];
const offers = [
    {
        id: 'butterfly-wings',
        name: 'Ailes de papillon',
        blurb: 'De grandes ailes de monarque, orange veiné de noir et semé de points blancs, qui battent dans ton dos. Animées.',
        items: [{ templateId: 'butterfly-wings' }],
        priceCents: 599,
    },
    {
        id: 'angel-wings',
        name: 'Ailes d’ange',
        blurb: 'Des ailes de plumes blanches au liseré d’or, qui s’ouvrent doucement dans ton dos. Animées.',
        items: [{ templateId: 'angel-wings' }],
        priceCents: 699,
    },
    {
        id: 'bat-wings',
        name: 'Ailes de chauve-souris',
        blurb: 'De fines ailes de cuir noir aux bords festonnés, qui claquent dans ton dos. Animées.',
        items: [{ templateId: 'bat-wings' }],
        priceCents: 599,
    },
    {
        id: 'crystal-sword',
        name: 'Épée de cristal',
        blurb: 'Une lame taillée dans une améthyste, violette et translucide, portée par-dessus ton arme.',
        items: [{ templateId: 'crystal-sword' }],
        priceCents: 399,
    },
    {
        id: 'banner-spear',
        name: 'Lance-étendard',
        blurb: 'Une lance de guerre qui porte ta bannière pourpre frappée d’une étoile d’or, par-dessus ton arme.',
        items: [{ templateId: 'banner-spear' }],
        priceCents: 349,
    },
    {
        id: 'battle-leek',
        name: 'Poireau de combat',
        blurb: 'Un poireau géant, frais du potager, tenu comme une épée. Tes ennemis ne s’en remettront pas.',
        items: [{ templateId: 'battle-leek' }],
        priceCents: 299,
    },
];
export const WINGS_WEAPONS = { templates, offers };
//# sourceMappingURL=wings-weapons.js.map